import {
  SdgAlignmentLevel,
  SdgAlignmentStrength,
  SdgAlignmentValence,
} from '@upright/common/model/output/scores/sdg-alignment/types';
import { Valence } from '@upright/common/model/types';
import { Side } from '../../../impact-lens-profile/common/layout/types';

export function toSdgAlignmentStrength(level: SdgAlignmentLevel) {
  switch (level) {
    case SdgAlignmentLevel.STRONGLY_MISALIGNED:
    case SdgAlignmentLevel.STRONGLY_ALIGNED:
      return SdgAlignmentStrength.STRONG;
    case SdgAlignmentLevel.ALIGNED:
    case SdgAlignmentLevel.MISALIGNED:
      return SdgAlignmentStrength.NORMAL;
    case SdgAlignmentLevel.WEAKLY_ALIGNED:
    case SdgAlignmentLevel.WEAKLY_MISALIGNED:
      return SdgAlignmentStrength.WEAK;
  }
}

export function toSdgAligmentValence(valence: Valence) {
  switch (valence) {
    case Valence.NEGATIVE:
      return SdgAlignmentValence.MISALIGNED;
    case Valence.POSITIVE:
      return SdgAlignmentValence.ALIGNED;
    default:
      throw Error('Unexpected valence');
  }
}

export function sideToSdgValence(side: Side): SdgAlignmentValence {
  return side === Side.LEFT ? SdgAlignmentValence.MISALIGNED : SdgAlignmentValence.ALIGNED;
}
